module.exports = __webpack_public_path__ + "static/media/workPvcCoatings7.2440cd32.jpg";